/**
 * Estimación de total / depósito 30% alineada con processRental + pending_rentals.
 * Misma promo (weekend / low season) + mismo seguro (resolveBookingInsuranceId).
 */
import {
  applyLowSeasonDiscountFor,
  buildRentalPromoSnapshot,
} from "./rentalPromo";
import {
  resolveBookingInsuranceId,
  resolveApplicableInsuranceId,
  dailyInsurancePriceFromList,
  isPaidInsurance,
  insuranceLabel,
} from "./rentalInsurance";

const round2 = n => Math.round(Number(n) * 100) / 100;

/**
 * @param {object} opts
 * @param {object} opts.booking - booking (r_gps, r_insurance, r_insurance_id, dates…)
 * @param {object} [opts.rental] - rental (dates/locations/from_agency si faltan en booking)
 * @param {number} opts.dailyMoto
 * @param {number} [opts.dailyGps=0]
 * @param {Array} [opts.insurancePrices] - filas prices type insurance
 * @param {number} [opts.oneWayFee=0]
 * @param {number} [opts.rewards=0]
 */
export function estimateRentalFromBooking(opts = {}) {
  const booking = opts.booking || {};
  const rental = opts.rental || {};
  const date_1 = rental.date_1 || booking.r_date_1 || booking.date_1;
  const time_1 = rental.time_1 || booking.r_time_1 || booking.time_1;
  const date_2 = rental.date_2 || booking.r_date_2 || booking.date_2;
  const time_2 = rental.time_2 || booking.r_time_2 || booking.time_2;
  const from_agency = !!(rental.from_agency || booking.from_agency);

  const promo = buildRentalPromoSnapshot({
    date_1,
    time_1,
    date_2,
    time_2,
    from_agency,
  });
  const motoDays = promo.moto_days;
  const extrasDays = promo.extras_days;

  const requestedId = resolveBookingInsuranceId(booking);
  const insuranceId = resolveApplicableInsuranceId(requestedId, extrasDays);
  const dailyMoto = Number(opts.dailyMoto) || 0;
  const dailyGps =
    booking.r_gps || booking.r_gps === 1
      ? Number(opts.dailyGps) || 0
      : 0;
  const dailyVip = dailyInsurancePriceFromList(
    opts.insurancePrices || [],
    insuranceId
  );
  const oneWayFee = Number(opts.oneWayFee) || 0;
  const rewards = Number(opts.rewards != null ? opts.rewards : booking.rewards) || 0;

  const motoTotal = applyLowSeasonDiscountFor(
    dailyMoto * motoDays,
    promo,
    "moto"
  );
  const gpsTotal = applyLowSeasonDiscountFor(
    dailyGps * extrasDays,
    promo,
    "gps"
  );
  const vipTotal = applyLowSeasonDiscountFor(
    dailyVip * extrasDays,
    promo,
    "vip"
  );
  const oneWayTotal = applyLowSeasonDiscountFor(oneWayFee, promo, "one_way");
  const total = round2(motoTotal + gpsTotal + vipTotal + oneWayTotal);
  const totalNet = round2(Math.max(0, total - rewards));
  const deposit30 = round2(totalNet * 0.3);

  return {
    promo,
    motoDays,
    extrasDays,
    insuranceId,
    insuranceLabel: insuranceLabel(insuranceId),
    paidInsurance: isPaidInsurance(insuranceId),
    dailyMoto,
    dailyGps,
    dailyVip,
    motoTotal,
    gpsTotal,
    vipTotal,
    oneWayTotal,
    total,
    totalNet,
    deposit30,
  };
}



// WEBPACK FOOTER //
// ./src/util/estimateRentalFromBooking.js